export default {
  title: 'Steuern & Währung',
  subtitle: 'Verwalten Sie die Steuerkategorien, mit denen Ihre Menüartikel bepreist werden.',
};
